import type { memberResource } from '@porotutu/api/features/crm/users/resource'
import { unwrap } from '@porotutu/react/api'
import type { ListMeta, ListQuery } from '@porotutu/react/paging'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { crm } from '@/api/client'
import { USERS } from '@/api/keys'
import type { MemberSort } from '../vocabulary'

export type Member = ReturnType<typeof memberResource>

export type MemberPage = { data: Member[]; meta: ListMeta }

export type MemberListQuery = ListQuery<MemberSort, never>

export const membersQuery = (query: MemberListQuery) =>
  queryOptions({
    queryKey: [...USERS, 'list', query] as const,
    queryFn: async () => unwrap(await crm.users.get({ query })),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  })
